import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    const isDesktop = window.matchMedia("(min-width: 768px)").matches

    this.panelTargets.forEach((panel, index) => {
      const shouldExpand = !isDesktop || index === 0
      panel.classList.toggle("is-expanded", shouldExpand)
    })
  }

  toggle(event) {
    const isDesktop = window.matchMedia("(min-width: 768px)").matches
    if (!isDesktop) return

    const panel = event.currentTarget.closest("[data-accordion-target='panel']")
    panel.classList.toggle("is-expanded")
  }
}
